<template>
  <section>
    <nav class="level is-mobile">
      <div class="level-left">
        <div class="level-item">
          <b-button type="is-success is-light"
                    icon-left="reload"
                    @click="fetchData">
            Reload Data Table
          </b-button>
        </div>
        <div class="level-item">
          <b-switch
              v-model="isDateMode"
              @input="onModeToggle"
              type="is-primary"
              :rounded="true"
          >
            <span v-if="isDateMode">Mode Column = LAB ID  </span>
            <span v-else>Mode Column = LAB Param  </span>
          </b-switch>
        </div>
        <div class="level-item">
          <b-switch v-model="colorByFlag" @input="onToggleColorByFlag">
            ใช้สีตาม Flag
          </b-switch>
        </div>

        <div class="level-item">
          <div class="level-item">
            <b-switch v-model="isFilterText" @input="onToggleFilterText()">
              Filter Text
            </b-switch>
          </div>
        </div>

        <div class="level-item group-filter-box" >
          <div class="level-item">
            <span class="has-text-grey-dark mr-3 ">Filter Group</span>
            <b-checkbox
                v-for="g in groupFilters"
                :key="g.value"
                v-model="selectedGroups"
                :native-value="g.value"
                @input="onChangeGroupFilter"
                class="mr-5"
            >
              {{ g.label }}
            </b-checkbox>

          </div>
        </div>
      </div>

      <div class="level-right">
      </div>
    </nav>

    <nav class="level is-mobile filter-bar" v-if="isFilterText">
      <div class="level-left">
        <div class="level-item">
          <b-field grouped position="is-left" class="filters">
            <b-field
                v-for="(f, i) in filterTerms"
                :key="'flt-'+i"
                expanded
                class="filter-cell"
            >
              <template slot="label">
                <b-checkbox v-model="f.enabled" size="is-small" @input="applyFilter">
                  #{{ i + 1 }}
                </b-checkbox>
              </template>

              <b-input
                  v-model.trim="f.text"
                  placeholder="พิมพ์ชื่อ params เช่น WBC, Reticulo..."
                  size="is-small"
                  :disabled="!f.enabled"
                  @input="applyFilter"
                  @keyup.native.enter="applyFilter"
              />
            </b-field>
          </b-field>
        </div>

        <div class="level-item">
          <div class="filter-actions mt-5">
            <b-button size="is-small" @click="clearFilters">
              ล้างข้อความ
            </b-button>
            <b-button size="is-small" @click="enableAllFilters">
              เปิดทั้งหมด
            </b-button>
            <b-button size="is-small" @click="disableAllFilters">
              ปิดทั้งหมด
            </b-button>
          </div>
        </div>
      </div>
    </nav>

    <!-- Grid -->
    <ag-grid-vue
        class="ag-theme-alpine grid"
        :gridOptions="gridOptions"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :defaultColDef="defaultColDef"
        :frameworkComponents="frameworkComponents"
        :animateRows="true"
        :rowSelection="'single'"
        :domLayout="'normal'"
        :tooltipShowDelay="0"
        :enableCellTextSelection="true"
        @grid-ready="onGridReady"
    />
  </section>
</template>

<script>
import axios from "axios";
import { AgGridVue } from "ag-grid-vue";
import _ from "lodash";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { getBaseURLforBackEnd, getConfigAxios } from "@/utils";
import { mapState } from "vuex";

import ValueWithTagsRenderer from "./ValueWithTagsRenderer.vue";
import ParamsNameWithCodeRenderer from './ParamsNameWithCodeRenderer.vue';
import ParamsNameWithCodeHeader from './ParamsNameWithCodeHeader.vue';

const MODE_KEY = 'cbc_view_mode'; // 'byLab' | 'byDate'
const COLOR_FLAG_KEY  = 'cbc_color_by_flag';
const FILTER_TEXT_KEY = 'cbc_filter_text';

export default {
  name: "CBC_Table_V3",
  /* eslint-disable vue/no-unused-components */
  components: {
    AgGridVue,
    ValueWithTagsRenderer,
    ParamsNameWithCodeRenderer,
    ParamsNameWithCodeHeader,
  },
  computed: {
    ...mapState({
      access_token: (s) => s.master_data.access_token,
     // opdInfoInVetRoom : state => state.vetroom.opdInfoInVetRoom ,
       OPDSelected : state => state.opd_target.opd_selected, // ใน kuvdl
    }),
    activeFilters() {
      return (this.filterTerms || [])
          .filter(f => f.enabled && f.text && f.text.toString().trim() !== "")
          .map(f => f.text.toString().trim().toLowerCase());
    },
  },
  data() {
    return {
      mode: "byLab",      // 'byLab' | 'byDate'
      isDateMode: false,

      lastResp: null,

      codesAll: [],   // [{code,name,grp_id,grp_name}]
      rowsAll: [],

      isFilterText : false,
      filterTerms: [
        { enabled: false, text: "" },
        { enabled: false, text: "" },
        { enabled: false, text: "" },
        { enabled: false, text: "" },
        { enabled: false, text: "" },
      ],
      codesFiltered: [],

      groupFilters: [],   // [{value,label}]
      selectedGroups: [],
      codeGroupMap: {},   // code -> grpName

      gridApi: null,
      gridColumnApi: null,
      gridOptions: { context: { colorByFlag: true } },
      columnDefs: [],
      rowData: [],
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        suppressHeaderMenuButton: true,
        tooltipValueGetter: (p) => (typeof p.value === "string" ? p.value : ""),
      },

      colorByFlag: true,

      frameworkComponents: {
        ValueWithTagsRenderer,
        ParamsNameWithCodeRenderer,
        ParamsNameWithCodeHeader,
      },
    };
  },
  mounted() {
    const saved = localStorage.getItem(MODE_KEY);
    this.mode = saved === 'byDate' ? 'byDate' : 'byLab';

    this.colorByFlag = this.getLSBool(COLOR_FLAG_KEY, true);
    this.isFilterText = this.getLSBool(FILTER_TEXT_KEY, false);

    this.isDateMode = (this.mode === 'byDate');

    if (this.lastResp) {
      this.applyFilter();
      this.$nextTick(this.redrawColors);
    }
  },
  methods: {
    getLSBool(key, def = false) {
      try {
        const v = localStorage.getItem(key);
        if (v === null) return def;
        return !!JSON.parse(v);
      } catch (e) {
        this._lsMem = this._lsMem || {};
        if (Object.prototype.hasOwnProperty.call(this._lsMem, key)) {
          return !!this._lsMem[key];
        }
        if (process && process.env && process.env.NODE_ENV !== 'production') {
          console.warn('[getLSBool] fallback to memory:', key, e && e.message);
        }
        return def;
      }
    },
    setLSBool(key, val) {
      try {
        localStorage.setItem(key, JSON.stringify(!!val));
      } catch (e) {
        this._lsMem = this._lsMem || {};
        this._lsMem[key] = !!val;
        if (process && process.env && process.env.NODE_ENV !== 'production') {
          console.warn('[setLSBool] saved to memory (ls unavailable):', key, e && e.message);
        }
      }
    },

    onToggleColorByFlag(val) {
      this.setLSBool(COLOR_FLAG_KEY, val);
      this.redrawColors();
    },
    onToggleFilterText(val) {
      this.setLSBool(FILTER_TEXT_KEY, val);
      if (!val) this.disableAllFilters();
    },

    formatValWithArrow(payload) {
      const val = payload?.val ?? "";
      return val;
    },

    onModeToggle(val) {
      const next = val ? 'byDate' : 'byLab';
      if (this.mode !== next) {
        localStorage.setItem(MODE_KEY, next);
        this.switchMode(next);
      }
    },

    // ========= AG Grid =========
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.redrawColors();
      this.$nextTick(this.autoSizeColumns);
    },
    redrawColors() {
      if (this.gridApi && typeof this.gridApi.setGridOption === 'function') {
        this.gridApi.setGridOption('context', { colorByFlag: this.colorByFlag });
      } else {
        this.gridOptions.context = this.gridOptions.context || {};
        this.gridOptions.context.colorByFlag = this.colorByFlag;
      }
      this.gridApi && this.gridApi.refreshCells({ force: true, suppressFlash: true });
    },
    autoSizeColumns() {
      if (!this.gridApi || !this.gridApi.getColumns) return;
      const allCols = this.gridApi.getColumns() || [];
      if (!allCols.length) return;
      const colIds = allCols.map(c => c.getColId());
      if (this.gridApi.autoSizeColumns) {
        this.gridApi.autoSizeColumns(colIds);
      } else if (this.gridApi.autoSizeAllColumns) {
        this.gridApi.autoSizeAllColumns();
      }
    },

    // group filter -> re-apply filter (ทุก mode)
    onChangeGroupFilter() {
      this.applyFilter();
    },

    // ========= Backend =========
    async fetchData() {
      try {
    //    const body = { idopd: this.opdInfoInVetRoom.idopd };
         const body = { idopd: this.OPDSelected.idopd };
        const baseCfg = (typeof getConfigAxios === 'function') ? getConfigAxios() : {};
        const cfg = {
          ...baseCfg,
          headers: {
            ...(baseCfg.headers || {}),
            Authorization: `Bearer ${this.access_token}`,
          },
        };

        const { data } = await axios.post(
            `${getBaseURLforBackEnd()}/api/labcbclist_spec_opdno_v3`,
            body,
            cfg
        );

        this.lastResp = data;

        const { codes, rows } = this.normalizeResponse(this.lastResp);
        this.codesAll = codes;
        this.rowsAll  = rows;

        // สร้าง groupFilters + codeGroupMap
        const groupMap = {};
        const codeGroupMap = {};

        this.codesAll.forEach(c => {
          const grpName = c.grp_name || 'ungroup';
          if (c.code) {
            codeGroupMap[c.code] = grpName;
          }
          if (!groupMap[grpName]) {
            groupMap[grpName] = {
              value: grpName,
              label: grpName,
            };
          }
        });

        this.codeGroupMap = codeGroupMap;
        this.groupFilters = Object.values(groupMap);
        this.selectedGroups = this.groupFilters.map(g => g.value); // เปิดทุก group ตอนแรก

        if (!Array.isArray(this.filterTerms) || this.filterTerms.length === 0) {
          this.filterTerms = [{ enabled: false, text: "" }];
        }

        this.applyFilter();
        this.$nextTick(this.redrawColors);
      } catch (e) {
        console.error(e);
        alert("โหลดข้อมูลไม่สำเร็จ");
      }
    },

    switchMode(nextMode) {
      if (this.mode === nextMode) return;
      this.mode = nextMode;
      this.isDateMode = (this.mode === 'byDate');
      localStorage.setItem(MODE_KEY, this.mode);

      if (!this.lastResp) return;
      this.applyFilter();
      this.$nextTick(this.redrawColors);
    },

    // ========= Helpers =========
    normalizeResponse(resp) {
      let codes = [];
      if (Array.isArray(resp.codes) && resp.codes.length > 0) {
        if (resp.codes[0] && typeof resp.codes[0] === "object" && "code" in resp.codes[0]) {
          codes = resp.codes; // {code,name,grp_id,grp_name}
        } else {
          codes = resp.codes.map((o) => {
            const k = Object.keys(o || {})[0];
            return { code: k, name: o[k] };
          });
        }
      }
      return { codes, rows: resp.rows || [] };
    },

    formatTooltipPayload(x) {
      if (!x) return "";
      const parts = [];
      if (x.nameLis) parts.push(x.nameLis);
      const hasVal = x.val !== undefined && x.val !== null && x.val !== "";
      const unit = x.unitName || "";
      if (hasVal || unit) parts.push(`${hasVal ? x.val : "-"}` + (unit ? ` ${unit}` : ""));
      if (x.refVal)     parts.push(`Ref: ${x.refVal}`);
      if (x.machineId)  parts.push(`Machine: ${x.machineId}`);
      if (x.flag)       parts.push(`Flag: ${x.flag}`);
      if (x.dtRec)      parts.push(x.dtRec);
      return parts.join(" | ");
    },

    makeFlagStyle(getPayload) {
      return (p) => {
        const useColor = p.context && p.context.colorByFlag;
        const payload  = getPayload(p);
        const flag = (payload && payload.flag || "").toString().trim().toUpperCase();

        if (!useColor) return { color: "", fontWeight: "" };

        if (["H","L","HH","LL"].includes(flag)) {
          return { color: "#dc2626", fontWeight: "700" };
        }
        return { color: "", fontWeight: "" };
      };
    },

    // text filter (code+name)
    filterCodesByText(codes) {
      const needles = this.activeFilters;
      if (needles.length === 0) return codes.slice();
      return codes.filter(({ code, name }) => {
        const hay = `${code || ""} ${name || ""}`.toLowerCase();
        return needles.some(n => hay.includes(n));
      });
    },

    // รวม text filter + group filter
    makeCodesForView() {
      let codes = this.codesAll.slice();

      codes = this.filterCodesByText(codes);

      if (this.selectedGroups && this.selectedGroups.length > 0) {
        const activeSet = new Set(this.selectedGroups);
        codes = codes.filter(c => {
          const grpName = c.grp_name || 'ungroup';
          return activeSet.has(grpName);
        });
      } else {
        codes = []; // ปิดทุก group = ไม่แสดง param
      }

      return codes;
    },

    makeValueCellRenderer(getPayload) {
      return (p) => {
        const payload = getPayload(p);
        const val = payload?.val ?? "";
        const f = (payload?.flag || "").toString().trim().toUpperCase();
        const arrow = f === "H" ? "↑ " : f === "L" ? "↓ " : "";

        const unit = payload?.unitName || "";
        const ref  = payload?.refVal || "";

        const wrap = document.createElement('span');
        wrap.className = 'val-wrap';

        const v = document.createElement('span');
        v.className = 'val-text';
        v.textContent = arrow + val;
        wrap.appendChild(v);

        if (unit) {
          const u = document.createElement('span');
          u.className = 'tag-chip unit';
          u.textContent = unit;
          wrap.appendChild(u);
        }
        if (ref) {
          const r = document.createElement('span');
          r.className = 'tag-chip ref';
          r.textContent = ref;
          wrap.appendChild(r);
        }
        return wrap;
      };
    },

    applyFilter() {
      const codesView = this.makeCodesForView();
      this.codesFiltered = codesView;

      if (this.mode === "byLab") {
        this.columnDefs = this.makeColumnDefsByLab(this.codesFiltered);
        this.rowData = this.rowsAll;
      } else {
        this.buildByDateFromByLab(this.codesFiltered);
      }

      this.$nextTick(() => {
        this.redrawColors();
        this.autoSizeColumns();
      });
    },

    clearFilters() {
      this.filterTerms.forEach(f => f.text = "");
      this.applyFilter();
    },
    enableAllFilters() {
      this.filterTerms.forEach(f => f.enabled = true);
      this.applyFilter();
    },
    disableAllFilters() {
      this.filterTerms.forEach(f => f.enabled = false);
      this.applyFilter();
    },

    // ================= Mode: byLab =================
    makeColumnDefsByLab(codes) {
      const fmtTip  = this.formatTooltipPayload;
      const flagSty = this.makeFlagStyle.bind(this);

      // ใช้ codesAll ทั้งชุดสำหรับคำนวณ dt ของ LAB No.
      const allCodesForDt = (this.codesAll && this.codesAll.length)
          ? this.codesAll
          : codes;

      const latestDtInRow = (row) => {
        const dts = allCodesForDt
            .map(({ code }) => row?.[code]?.dtRec)
            .filter(Boolean);
        if (!dts.length) return null;
        const best = dts
            .map((s) => ({ s, t: Date.parse(s) }))
            .sort((a, b) =>
                (Number.isNaN(a.t) ? -Infinity : a.t) -
                (Number.isNaN(b.t) ? -Infinity : b.t)
            )
            .pop();
        return best?.s || dts[dts.length - 1];
      };

      const base = [{
        headerName: "LAB No.",
        valueGetter: (p) => {
          const idlab = p.data?.idlab || "";
          const dt = latestDtInRow(p.data);
          return dt ? `${idlab} (${dt})` : idlab;
        },
        pinned: "left",
        lockPinned: true,
        lockPosition: true,
        suppressMovable: true,
        width: 220,
        cellClass: "ag-cell-wrap-text",
        tooltipValueGetter: (p) => p.value,
      }];

      const codeCols = codes.map(({ code, name }) => ({
        colId: code,
        headerComponent: 'ParamsNameWithCodeHeader',
        headerComponentParams: {
          userData: { code },
          name,
        },
        valueGetter: (p) => {
          const x = p.data?.[code];
          if (!x) return null;
          return x.valNum != null
              ? x.valNum
              : (x.val != null ? parseFloat(String(x.val)) : null);
        },
        cellRenderer: 'ValueWithTagsRenderer',
        cellRendererParams: {
          getPayload: (p) => p.data?.[code],
        },
        tooltipValueGetter: (p) => fmtTip(p.data?.[code]),
        cellStyle: flagSty((p) => p.data?.[code]),
        cellClass: "text-right",
        minWidth: 130,
        pinned: null,
        lockPinned: true,
      }));

      return [...base, ...codeCols];
    },

    // ================= Mode: byDate-IDLAB =================
    buildByDateFromByLab(codesOverride = null) {
      const fmtTip  = this.formatTooltipPayload;
      const flagSty = this.makeFlagStyle.bind(this);

      const codes = codesOverride ? codesOverride : this.codesAll;
      const rows  = this.rowsAll;

      // ใช้ codesAll ทั้งชุดในการหาวันที่ล่าสุดของแต่ละ LAB (ให้ header มีวันที่เสมอ)
      const allCodesForDt = (this.codesAll && this.codesAll.length)
          ? this.codesAll
          : codes;

      const latestDtInRow = (row) => {
        const dts = allCodesForDt
            .map(({ code }) => row?.[code]?.dtRec)
            .filter(Boolean);
        if (!dts.length) return null;
        const best = _.maxBy(
            dts.map((s) => ({ s, t: Date.parse(s) })),
            (o) => (Number.isNaN(o.t) ? -Infinity : o.t)
        );
        return best?.s || dts[dts.length - 1];
      };

      // helper: ตรวจว่า row นี้มีค่าใน "codes" (กลุ่มที่เลือก) อย่างน้อย 1 ตัวไหม
      const hasVisibleValue = (row) => {
        return codes.some(({ code }) => {
          const payload = row?.[code];
          if (!payload) return false;
          const v = payload.val;
          return v !== null && v !== undefined && v !== "";
        });
      };

      // สร้าง meta ของ column เฉพาะ LAB ที่มีค่าใน group ที่เลือก
      let colMeta = rows
          .filter((r) => hasVisibleValue(r))    // << บรรทัดนี้คือ filter หลัก
          .map((r) => {
            const dt = latestDtInRow(r) || "";
            const t  = Date.parse(dt || "");
            const idNum = Number.isFinite(+r.idlab) ? +r.idlab : -Infinity;
            return {
              idlab: r.idlab,
              idNum,
              dt,
              t: Number.isNaN(t) ? -Infinity : t,
              key: dt ? `${dt} • ${r.idlab}` : `${r.idlab}`,
            };
          });

      colMeta = _.orderBy(colMeta, [(o) => o.t, (o) => o.idNum], ["desc", "desc"]);

      const rowsByIdlab = _.keyBy(rows, "idlab");

      const rowsOut = codes.map(({ code, name }) => {
        const row = { name, _code: code };
        for (const m of colMeta) {
          const payload = _.get(rowsByIdlab[m.idlab], [code]);
          row[m.key] = payload?.val ?? "";
        }
        return row;
      });

      const baseCols = [{
        headerName: "LAB Param",
        field: "name",
        pinned: "left",
        lockPinned: true,
        lockPosition: true,
        suppressMovable: true,
        width: 220,
        cellRenderer: 'ParamsNameWithCodeRenderer',
      }];

      const dateCols = colMeta.map((m) => ({
        headerName: m.key,
        field: m.key,
        width: 180,
        valueGetter: (p) => {
          const v = _.get(p.data, m.key);
          const n = parseFloat(String(v));
          return Number.isFinite(n) ? n : null;
        },
        cellRenderer: 'ValueWithTagsRenderer',
        cellRendererParams: {
          getPayload: (p) => {
            const code = p.data?._code;
            return code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
          },
        },
        tooltipValueGetter: (p) => {
          const code = p.data?._code;
          const payload = code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
          return fmtTip(payload);
        },
        cellStyle: flagSty((p) => {
          const code = p.data?._code;
          return code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
        }),
        cellClass: "text-right",
        pinned: null,
        lockPinned: true,
      }));

      this.columnDefs = [...baseCols, ...dateCols];
      this.rowData = rowsOut;
    },
    // buildByDateFromByLab(codesOverride = null) {
    //   const fmtTip  = this.formatTooltipPayload;
    //   const flagSty = this.makeFlagStyle.bind(this);
    //
    //   const codes = codesOverride ? codesOverride : this.codesAll;
    //   const rows  = this.rowsAll;
    //
    //   const latestDtInRow = (row) => {
    //     const dts = codes.map(({ code }) => row?.[code]?.dtRec).filter(Boolean);
    //     if (!dts.length) return null;
    //     const best = _.maxBy(
    //         dts.map((s) => ({ s, t: Date.parse(s) })),
    //         (o) => (Number.isNaN(o.t) ? -Infinity : o.t)
    //     );
    //     return best?.s || dts[dts.length - 1];
    //   };
    //
    //   let colMeta = rows.map((r) => {
    //     const dt = latestDtInRow(r) || "";
    //     const t  = Date.parse(dt || "");
    //     const idNum = Number.isFinite(+r.idlab) ? +r.idlab : -Infinity;
    //     return {
    //       idlab: r.idlab,
    //       idNum,
    //       dt,
    //       t: Number.isNaN(t) ? -Infinity : t,
    //       key: dt ? `${dt} • ${r.idlab}` : `${r.idlab}`,
    //     };
    //   });
    //   colMeta = _.orderBy(colMeta, [(o) => o.t, (o) => o.idNum], ["desc", "desc"]);
    //
    //   const rowsByIdlab = _.keyBy(rows, "idlab");
    //
    //   const rowsOut = codes.map(({ code, name }) => {
    //     const row = { name, _code: code };
    //     for (const m of colMeta) {
    //       const payload = _.get(rowsByIdlab[m.idlab], [code]);
    //       row[m.key] = payload?.val ?? "";
    //     }
    //     return row;
    //   });
    //
    //   const baseCols = [{
    //     headerName: "LAB Param",
    //     field: "name",
    //     pinned: "left",
    //     lockPinned: true,
    //     lockPosition: true,
    //     suppressMovable: true,
    //     width: 220,
    //     cellRenderer: 'ParamsNameWithCodeRenderer',
    //   }];
    //
    //   const dateCols = colMeta.map((m) => ({
    //     headerName: m.key,
    //     field: m.key,
    //     width: 180,
    //     valueGetter: (p) => {
    //       const v = _.get(p.data, m.key);
    //       const n = parseFloat(String(v));
    //       return Number.isFinite(n) ? n : null;
    //     },
    //     cellRenderer: 'ValueWithTagsRenderer',
    //     cellRendererParams: {
    //       getPayload: (p) => {
    //         const code = p.data?._code;
    //         return code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
    //       },
    //     },
    //     tooltipValueGetter: (p) => {
    //       const code = p.data?._code;
    //       const payload = code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
    //       return fmtTip(payload);
    //     },
    //     cellStyle: flagSty((p) => {
    //       const code = p.data?._code;
    //       return code ? _.get(rowsByIdlab[m.idlab], [code]) : null;
    //     }),
    //     cellClass: "text-right",
    //     pinned: null,
    //     lockPinned: true,
    //   }));
    //
    //   this.columnDefs = [...baseCols, ...dateCols];
    //   this.rowData = rowsOut;
    // },


    //d
  },
  watch: {
    mode(newVal) {
      this.isDateMode = (newVal === 'byDate');
    }
  },
};
</script>

<style scoped>
.toolbar { display: flex; align-items: center; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
.input { padding: 6px 10px; border: 1px solid #ddd; border-radius: 6px; }
.input.small { padding: 4px 8px; min-width: 320px; }
.btn { padding: 6px 12px; border: 1px solid #0ea5e9; background: #0ea5e9; color: #fff; border-radius: 6px; }
.btn.ghost { background: transparent; color: #0ea5e9; }
.btn.active { background: #0369a1; border-color: #0369a1; }
.spacer { flex: 1 1 auto; }

.grid { width: 100%; height: 61vh; }
.text-right .ag-cell-value { text-align: right; }

.ml-2 { margin-left: 8px; }
.flex { display: flex; }
.items-center { align-items: center; }
.gap-2 { gap: 8px; }

.filter-bar {
  background-color: #f8f6f6;
  border: 1px solid #fecaca;
  border-left: 4px solid #f87171;
  border-radius: 10px;
  padding: 10px 12px;
}
.filter-bar .level-left { align-items: flex-start; }
.filter-bar .level-item { margin-right: 12px; }

.filter-bar .filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.filter-bar .filter-cell { min-width: 220px; }

.filter-bar .input { background-color: #ffffff; }

.filter-bar .b-input input.input.is-small { height: 2.1em; }

.filter-bar .b-checkbox { font-weight: 600; }
.filter-bar .b-checkbox .control-label { color: #8b8ac5; }

.filter-bar .filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-bar .button { box-shadow: none; }
.filter-bar .button.is-small { height: 2em; }

.filter-bar:hover { border-color: #d25050; }

.val-wrap { display: inline-flex; align-items: center; gap: 6px; }
.val-text { line-height: 1.2; }
.tag-chip { display: inline-block; padding: 0.05rem 0.35rem; border-radius: 10px; font-size: 0.75em; line-height: 1.3; white-space: nowrap; border: 1px solid transparent; }
.tag-chip.unit { background: #f3f4f6; color: #374151; border-color: #e5e7eb; }
.tag-chip.ref  { background: #eff6ff; color: #1d4ed8; border-color: #bfdbfe; }


.group-filter-box {
  background-color: #faf9f9;   /* เทาจาง */
  padding: 6px 10px;           /* ระยะห่างด้านใน */
  border-radius: 6px;          /* มุมโค้ง */
  border: 1px solid #fafafa;   /* เส้นขอบจาง */
}


</style>
